import Channel from '../views/WxPull/Channel.vue';
import Article from '../views/WxPull/Article.vue';
let WxPull = [
  {
    path: 'Channel',
    name: '公众号分类',
    component: Channel
  },
  {
    path: 'Article',
    name: '文章列表',
    component: Article
  }
];

export default WxPull;
